import { faRecycle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Accordion } from "flowbite-react";
import React from "react";

export default function AboutMission() {
  return (
    <div className="container mt-20">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="col-span-1 custom-bg-about-mission"></div>

        <div className="col-span-1 flex justify-center items-center bg-gray-200">
          <div className="w-5/6 mt-5">
            <FontAwesomeIcon
              icon={faRecycle}
              className="text-3xl text-lime-600"
            />
            <h5 className="font-bold text-5xl mt-3">Our Mission</h5>
            <p className="text-base">About Us</p>

            <p className="text-slate-400 mt-3">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet quos
              vero iure veritatis voluptate dolorum eius nostrum atque, saepe
              quae.
            </p>

            <Accordion className="mt-2">
              <Accordion.Panel>
                <Accordion.Title>REDUCING WASTE</Accordion.Title>
                <Accordion.Content>
                  <p className="text-slate-400">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quam neque quae iusto sed, quibusdam repellendus repellat aliquam molestiae sunt maxime beatae fugit blanditiis libero commodi cumque? Doloremque deleniti voluptatem architecto facilis quia ea provident quis.
                  </p>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title color="bg-lime-600">REDUCE PROGRAM</Accordion.Title>
                <Accordion.Content>
                  <p className="text-slate-400">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quam neque quae iusto sed, quibusdam repellendus repellat aliquam molestiae sunt maxime beatae fugit blanditiis libero commodi cumque? Doloremque deleniti voluptatem architecto facilis quia ea provident quis.
                  </p>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title>RECYLCLE MORE</Accordion.Title>
                <Accordion.Content>
                  <p className="text-slate-400">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quam neque quae iusto sed, quibusdam repellendus repellat aliquam molestiae sunt maxime beatae fugit blanditiis libero commodi cumque? Doloremque deleniti voluptatem architecto facilis quia ea provident quis.
                  </p>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}
